// @flow
import React, { Fragment, type Node } from 'react';

import CSSSticky from 'app/common/ui-components/css-sticky';
import SimpleDate from 'app/dataProviders/SimpleDate';

import ControlsLayout from '../ControlsLayout';
import DnevnikHeader from './DnevnikHeader';
import DnevnikContent from './DnevnikContent';

import styles from './Dnevnik.scss';


type Props = {
  studentId: string,
  date: SimpleDate,
  klassId: string,
  children?: Node,
  additionalControls?: Node,
  onPrevWeek: null | () => void,
  onNextWeek: null | () => void,
}

const Dnevnik = ({
  studentId,
  date,
  klassId,
  children,
  additionalControls,
  onPrevWeek,
  onNextWeek,
}: Props): Node => {
  return (
    <Fragment>
      <CSSSticky
        number={1}
        className={styles.stickable}
        shadowClassName={styles.shadow}
      >
        <ControlsLayout leftContent={additionalControls}>
          {children || null}
        </ControlsLayout>
        <DnevnikHeader
          day={date}
          onPrevWeek={onPrevWeek}
          onNextWeek={onNextWeek}
        />
      </CSSSticky>

      <DnevnikContent
        klassId={klassId}
        studentId={studentId}
        day={date}
      />
    </Fragment>
  );
};

export default Dnevnik;
